<template>
    <v-container fluid fill-height class="login-container">
        <Headful title="Welkom"></Headful>
        <Header
            color="white"
            extended
            show-logo
            :dark="false"
        ></Header>
        <v-layout align-center justify-center class="flex-fill">
            <v-flex>
                <v-card class="elevation-0 intro-card">
                    <v-card-text>
                        <h1 class="text-h4 mt-3 mb-5 text-center">Welkom</h1>
                        <p class="text-center">POrtaal is hét platform voor professionals in het Primair Onderwijs in onderwijsregio Drechtsteden
                            / West-Brabant.</p>
                        <p class="mb-8 text-center">In het portaal faciliteren we bovenbestuurlijke mobiliteit en bieden we beschikbare diensten voor starters, professionalisering en duurzame inzetbaarheid aan.</p>
                        <div class="intro-actions">
                            <!-- Kandidaten zijn afgeschermd; deze route dwingt eerst het loginscherm af. -->
                            <v-btn :to="{ name: 'SignIn' }" color="white" block rounded class="intro-action-btn mb-3 elevation-0">
                                <span class="intro-action-icon">
                                    <v-icon small>fal fa-users</v-icon>
                                </span>
                                Bekijk beschikbare kandidaten
                                <v-icon small class="intro-action-chevron">fal fa-chevron-right</v-icon>
                            </v-btn>
                            <v-btn :to="{ name: 'RegisterProfile' }" color="white" block rounded class="intro-action-btn mb-3 elevation-0">
                                <span class="intro-action-icon">
                                    <v-icon small>fal fa-user</v-icon>
                                </span>
                                Mijn profiel insturen
                                <v-icon small class="intro-action-chevron">fal fa-chevron-right</v-icon>
                            </v-btn>
                            <!-- Diensten zijn publiek: dit landt op het dashboard, zonder het mobiliteitsportaal. -->
                            <v-btn :to="{ name: 'Home' }" color="white" block rounded class="intro-action-btn mb-3 elevation-0">
                                <span class="intro-action-icon">
                                    <v-icon small>fal fa-building</v-icon>
                                </span>
                                Bekijk diensten
                                <v-icon small class="intro-action-chevron">fal fa-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Headful from "@/components/layout/Headful";
import Header from "@/components/layout/Header";

export default {
    name: "Login",
    components: {
        Headful,
        Header
    },
    mounted () {
        if (this.$store.state.auth.isLoggedIn) {
            this.$router.push({name: "Home"});
        }
    },
}
</script>

<style scoped>
.intro-card .v-card__text {
    max-width: 700px;
    margin: 0 auto;
}
</style>
